import React from "react";

// 2026-10-30T... -> "30 Oct 2026"
export const fmtDate = (value) =>
  value
    ? new Date(value).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

// Positive / Improvement / Achieved / Pending counters (Improvement = Achieved + Pending)
export function Badges({ counts }) {
  const c = counts || {};

  return (
    <span className="er-badges">
      <span className="er-badge er-b-pos">Positive : {c.positive || 0}</span>
      <span className="er-badge er-b-imp">
        Improvement : {c.improvement || 0}
      </span>
      <span className="er-badge er-b-ach">Achieved : {c.achieved || 0}</span>
      <span className="er-badge er-b-pen">Pending : {c.pending || 0}</span>
    </span>
  );
}
